import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles.css';
import logo from '../imgs/logo.png'; 





const Navbar = () => {
  // Prevent submenu overflow: flip alignment if it would go off-screen
  useEffect(() => {
    const root = document.querySelector('.nav-menu');
    if (!root) return;

    const handleTopEnter = (e) => {
      const li = e.currentTarget;
      const dropdown = li.querySelector(':scope > .dropdown');
      if (!dropdown) return;
      dropdown.classList.remove('align-right');
      const rect = dropdown.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        dropdown.classList.add('align-right');
      }
    };

    const handleTopLeave = (e) => {
      const dropdown = e.currentTarget.querySelector(':scope > .dropdown');
      if (dropdown) dropdown.classList.remove('align-right');
    };

    const handleNestedEnter = (e) => {
      const li = e.currentTarget;
      const submenu = li.querySelector(':scope > .dropdown');
      if (!submenu) return;
      submenu.classList.remove('open-left');
      const rect = submenu.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        submenu.classList.add('open-left');
      }
    };

    const handleNestedLeave = (e) => {
      const submenu = e.currentTarget.querySelector(':scope > .dropdown');
      if (submenu) submenu.classList.remove('open-left');
    };

    const topLis = root.querySelectorAll(':scope > li');
    topLis.forEach((li) => {
      li.addEventListener('mouseenter', handleTopEnter);
      li.addEventListener('mouseleave', handleTopLeave);
    });

    const nestedLis = root.querySelectorAll('.dropdown > li');
    nestedLis.forEach((li) => {
      li.addEventListener('mouseenter', handleNestedEnter);
      li.addEventListener('mouseleave', handleNestedLeave);
    });

    const onResize = () => {
      // Optional: could re-evaluate open menus on resize if necessary
    };
    window.addEventListener('resize', onResize);

    return () => {
      topLis.forEach((li) => {
        li.removeEventListener('mouseenter', handleTopEnter);
        li.removeEventListener('mouseleave', handleTopLeave);
      });
      nestedLis.forEach((li) => {
        li.removeEventListener('mouseenter', handleNestedEnter);
        li.removeEventListener('mouseleave', handleNestedLeave);
      });
      window.removeEventListener('resize', onResize);
    };
  }, []);

    // Toggle mobile menu function
  const toggleMenu = () => {
    const navMenu = document.getElementById('nav-menu');
    const navToggle = document.getElementById('nav-toggle');
    navMenu.classList.toggle('show-menu');
    navToggle.classList.toggle('active');
  };

  // Close mobile menu when clicking a link
  const closeMenu = () => {
    const navMenu = document.getElementById('nav-menu');
    const navToggle = document.getElementById('nav-toggle');
    navMenu.classList.remove('show-menu');
    navToggle.classList.remove('active');
  };

  return (
    <nav id="navbar" className="navbar">
        <div className="container flex-between">
        <NavLink to="/" className="nav-logo" onClick={closeMenu}>
          <img src={logo} alt="Geneseq Logo" height="44" />
        </NavLink>
          <ul className="nav-menu" id="nav-menu">
            <li><NavLink to="/" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Home</NavLink></li>
            {/* About Us Dropdown */}
            <li className="nav-item">
              <NavLink to="/About" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>About</NavLink>
              {/* <div className="nav-link">About</div> */}
              <ul className="dropdown">
                  <li><NavLink to="/About" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Intro</NavLink></li>
                  <li><NavLink to="/vision" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Vision & Mission</NavLink></li>
                  <li><NavLink to="/leadership" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Leadership</NavLink></li>
                  <li><NavLink to="/ourcommitment" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Our Commitment</NavLink></li>
                  <li><NavLink to="/valueprop" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Value Proposition</NavLink></li>
                </ul>
              </li>

              {/* Services Us Dropdown */}
            <li>
              <NavLink to="/services">Services</NavLink>
              <ul className="dropdown">
                  <li>
                    <NavLink to="/geninfo" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>GENOMIC SERVICES</NavLink>
                  <ul className="dropdown">
                    <li><NavLink to="/sanger" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>SANGER SEQUENCING</NavLink></li>
                    <li><NavLink to="/microbail" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>MICROBIAL IDENTIFICATION</NavLink></li>
                    <li><NavLink to="/dnabarcod" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>DNA BARCODING</NavLink></li>
                    {/* <li><NavLink to="/microsatelite" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Micro Satellite Genotyping</NavLink></li> */}
                    <li><NavLink to="/genepres" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>GENE EXPRESSION</NavLink></li>
                    <li><NavLink to="/cattlegenot" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>NGS SERVICES</NavLink></li>
                  </ul>
                  </li>
                  <li>
                    <NavLink to="/genesynthsis" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>OLIGO SYNTHESIS</NavLink>
                    <ul className="dropdown">
                      {/* <li><NavLink to="/genesynthsis" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Gene Information</NavLink></li> */}
                      <li><NavLink to="/unmdoligo" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Modified and Unmodified Oligos</NavLink></li>
                      {/* <li><NavLink to="/mdoligo" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Modified Oligo</NavLink></li> */}
                    </ul>
                  </li>
                  {/* <li>
                    <NavLink to="/dnaauth" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Food Product Testing</NavLink>
                    <ul className="dropdown">
                      <li><NavLink to="/dnaauth" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>DNA Authenticity</NavLink></li>
                      <li><NavLink to="/basmithiauth" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Basmati Authenticity</NavLink></li>
                      <li><NavLink to="/meatauth" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Meat Authenticity</NavLink></li>
                      <li><NavLink to="/gmoauth" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>GMO Testing</NavLink></li>
                    </ul>
                  </li> */}
                  {/* <li><NavLink to="/coidtest" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Infectious Diseases Testing</NavLink>
                    <ul className="dropdown">
                      <li><NavLink to="/coidtest" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Covid-19 Testing</NavLink></li>  
                    </ul>
                  </li> */}
                </ul>

            </li>
            { /* Products Dropdown */}
            <li><NavLink to="/products">Products</NavLink>
            <ul className="dropdown">
                  {/* <li><NavLink to="/sangerseq" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Nimagen Products</NavLink>
                    <ul className="dropdown">
                      <li><NavLink to="/sangerseq" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Sanger Sequencing</NavLink></li>
                      <li><NavLink to="/easyseqlib" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Easy Seq NGS Library Prep</NavLink></li>
                      <li><NavLink to="/easyseqsample" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Easy Seq NGS Sample Tracking</NavLink></li>
                      <li><NavLink to="/microbioinf" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Microbiology Infectious Disease</NavLink></li>
                      <li><NavLink to="/humangentic" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Human Agentics</NavLink></li>
                      <li><NavLink to="/idseekapp" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>IDSeek Forensic Applications</NavLink></li>
                    </ul>
                  </li> */}
                  <li><NavLink to="/reagentskits" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>KITS & REAGENTS</NavLink></li>
                </ul>
            </li>
            <li><NavLink to="/downloads" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Downloads</NavLink></li>
            <li><NavLink to="/career">Careers</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
            <li><NavLink to="/newsupdates">Media</NavLink>
              <ul className="dropdown">
                <li><NavLink to="/newsupdates" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>News & Updates</NavLink></li>
                <li><NavLink to="/videogallry" onClick={closeMenu} className={({isActive}) => isActive ? "active" : ""}>Video Gallery</NavLink></li>
              </ul>
            </li>
          </ul>
          <button 
          className="nav-toggle" 
          id="nav-toggle" 
          aria-label="Open menu"
          onClick={toggleMenu}
        >
          <span></span><span></span><span></span>
        </button>
        </div>
    </nav>
  );
}

export default Navbar;